import React from 'react';

export default function BackgroundFX({ variant = 'default' }) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Grid */}
      <div className="absolute inset-0 grid-lines opacity-40" />
      {/* Radial glow top */}
      <div className="absolute -top-40 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-blue-500/10 blur-[120px] animate-float-slow" />
      {/* Bottom emerald */}
      <div className="absolute -bottom-40 -right-20 h-[420px] w-[520px] rounded-full bg-sky-500/10 blur-[120px] animate-float-slow-alt" />
      {variant === 'default' && (
        <div className="absolute top-1/3 -left-24 h-[380px] w-[380px] rounded-full bg-cyan-400/5 blur-[110px]" />
      )}
      {/* Fine dot grid overlay */}
      <div className="absolute inset-0 dot-grid opacity-30" />
      {/* Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#ffffff]" />
    </div>
  );
}
